import { buildOptionHoverIndicatorStyle } from "./dropdown-option-styles";
import { dataEl, type DataElScope } from "@/utils/dataEl";
const SELECTED_INDICATOR_POINTS = "20 6 9 17 4 12";
const DEFAULT_INDICATOR_POINTS = "9 18 15 12 9 6";
interface DropdownOptionHoverIndicatorProps {
    dataElScope: DataElScope;
    isHighlighted: boolean;
    isSelected: boolean;
    optionIdentity: string;
}
export function DropdownOptionHoverIndicator({ dataElScope, isHighlighted, isSelected, optionIdentity, }: DropdownOptionHoverIndicatorProps) {
    const points = isSelected
        ? SELECTED_INDICATOR_POINTS
        : DEFAULT_INDICATOR_POINTS;
    return (
      <div data-el={dataEl(dataElScope, "OptionHoverIndicator/Root")} style={buildOptionHoverIndicatorStyle(isHighlighted)}>
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polyline points={points}/>
        </svg>
      </div>
    );
}
